import { cloneDeep } from 'lodash'

const defaultForm = {
  reply_type: 'generic',
  message: '',
  buttons: [],
  cards: [],
  bot_name: '',
  message_type: 'text',
  typing_on_settings: 'off',
  delay_in_reply: 0,
  keywords: '',
  keyword_type: 'reply',
  postback_id: '',
  replies: [],
}
export default {
  namespaced: true,
  state: {
    form: { ...defaultForm },
    change: false,
    webview_forms: [],
    templates: [],
    templatesFetched: false,
    postbacks: [],
    tabTypeIndex: 0,
  },
  getters: {
    templates: (state: any) => state.templates,
    form: (state: any) => state.form,
    change: (state: any) => state.change,
    postbacks: (state: any) => state.postbacks,
    webview_forms: (state: any) => state.webview_forms,
    tabTypeIndex: (state: any) => state.tabTypeIndex,
  },
  mutations: {
    SET_FORM(state: any, payload: any) {
      state.form = { ...state.form, ...cloneDeep(payload) }
    },
    SET_TAB_INDEX(state: any, index: number) {
      state.tabTypeIndex = index
    },
    SET_DEFAULT_FORM(state: any) {
      state.form = { ...defaultForm }
    },
    SET_TYPE_INDEX(state: any, index: number) {
      state.tabTypeIndex = index
    },
    SET_TEMPLATES(state: any, templates: any) {
      state.templates = templates
    },
    SET_TEMPLATES_FETCHED(state: any, payload: any) {
      state.templatesFetched = payload
    },
  },
  actions: {

  },
}
